import {TreeNodeShape} from '/src/com/yext/sitesgitstorm/js/src/editor/tree/nodes/shapesJsDoc';
import {TreeSelectMode} from '/src/com/yext/sitesgitstorm/js/src/editor/tree/constants';
import {NodeType} from '/src/com/yext/sitesgitstorm/js/src/editor/tree/nodes/NodeConstants';

import {Checkbox} from '/ui/components/checkbox/checkbox';
import {Radio} from '/ui/components/radio/radio';

/**
 * @param {{
 *  node: !TreeNodeShape,
 *  treeSelectMode: string,
 *  onBulkSelect: (?function() | undefined),
 * }} props
 * @return {React.ReactNode}
 */
export const SelectMode = (props => {
  const {
    node,
    treeSelectMode,
    onBulkSelect,
  } = props;
  const renderTreeSelectMode = () => {
    switch (treeSelectMode) {
      case TreeSelectMode.NONE:
        return (
          <div title={node.path} className={'tree-node__file__text'}>
            {getDisplayNameForNode(node.type, node.displayName)}
          </div>
        );
      case TreeSelectMode.SINGLE:
        return (
          // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
          <div onClick={e => e.stopPropagation()}>
            <Radio
              key={node.id}
              id={node.id}
              label={
                <div title={node.path} className={'tree-node__file__text'}>
                  {getDisplayNameForNode(node.type, node.displayName)}
                </div>
              }
              checked={node.isBulkSelected}
              onChange={() => onBulkSelect && onBulkSelect()}
              value={node.id}
              disabled={node.displayName === '' && node.type === NodeType.DIRECTORY}
            />
          </div>
        );
      case TreeSelectMode.BULK:
        return (
          // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
          <div onClick={e => e.stopPropagation()}>
            <Checkbox
              key={node.id}
              id={node.id}
              label={
                <div title={node.path} className={'tree-node__file__text'}>
                  {getDisplayNameForNode(node.type, node.displayName)}
                </div>
              }
              checked={node.isBulkSelected}
              onChange={() => onBulkSelect && onBulkSelect()}
              value={node.id}
            />
          </div>
        );
      default:
        return null;
    }
  };
  return (<>
    {renderTreeSelectMode()}
  </>);
});

/**
 * @param {string} nodeType
 * @param {string} nodeDisplayName
 * @return {string}
 */
const getDisplayNameForNode = (nodeType, nodeDisplayName) => {
  if (nodeType === NodeType.DIRECTORY) {
    return nodeDisplayName ? nodeDisplayName : '/';
  } else {
    return nodeDisplayName;
  }
};
